// extracted by mini-css-extract-plugin
module.exports = {"diagramSkill":"styles_diagramSkill__1YtdK"};